import { render, staticRenderFns } from "./AssociateAssetToSiteComponent.vue?vue&type=template&id=0a40d062&scoped=true&"
import script from "./AssociateAssetToSiteComponent.vue?vue&type=script&lang=js&"
export * from "./AssociateAssetToSiteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a40d062",
  null
  
)

export default component.exports